<div
    class="sidebar-area bg-white box-shadow"
    [ngClass]="{ active: isToggled }"
    [class.dark-sidebar]="themeService.isSidebarDark()"
    [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()"
>
    <div class="logo bg-white">
        <a
            [routerLink]="'/' + routerUrl['mainLayout']"
            class="d-flex align-items-center"
        >
            <img [src]="mainLogo" alt="logo" class="main-logo" />
            <!-- <span> {{ "SIDEBAR.HEADER.TITLE" | translate }}</span> -->
        </a>
    </div>

    <div
        class="burger-menu"
        (click)="toggle()"
        [ngClass]="{ active: isToggled }"
    >
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
    </div>

    <ng-scrollbar visibility="hover" style="height: 100vh">
        <div class="sidebar-inner">
            <div class="sidebar-menu">
                <mat-accordion>
                    <!-- <span class="sub-title gray-color">MAIN</span> -->
                    <ng-container
                        *ngFor="
                            let mainSidebarList of mainSidebarList;
                            index as i
                        "
                    >
                        <ng-container
                            *ngIf="
                                !mainSidebarList.url && mainSidebarList.menuName
                            "
                        >
                            <ng-container
                                *ngIf="
                                    mainSidebarList?.permission | permissions
                                "
                            >
                                <mat-expansion-panel
                                    (opened)="toggleMailPanel(true, i)"
                                    (closed)="toggleMailPanel(false, i)"
                                >
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <i
                                                [class]="mainSidebarList.icon"
                                            ></i>
                                            <span class="title">{{
                                                mainSidebarList.menuName
                                                    | translate
                                            }}</span>
                                            <span
                                                class="badge"
                                                *ngIf="mainSidebarList.badge"
                                                >{{
                                                    mainSidebarList.badge
                                                }}</span
                                            >
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ul
                                        class="sidebar-sub-menu"
                                        *ngIf="
                                            mainSidebarList?.subMenus?.length
                                        "
                                    >
                                        <ng-container
                                            *ngFor="
                                                let subMenu of mainSidebarList?.subMenus
                                            "
                                        >
                                            <ng-container
                                                *ngIf="
                                                    subMenu?.permission
                                                        | permissions
                                                "
                                            >
                                                <li
                                                    class="sidemenu-item"
                                                    *ngIf="
                                                        subMenu.url &&
                                                        !subMenu?.redirectTo
                                                    "
                                                >
                                                    <a
                                                        class="sidemenu-link"
                                                        [routerLink]="
                                                            subMenu.url
                                                        "
                                                        routerLinkActive="active"
                                                        [routerLinkActiveOptions]="{
                                                            exact: true
                                                        }"
                                                    >
                                                        {{
                                                            subMenu.menuName
                                                                | translate
                                                        }}
                                                    </a>
                                                </li>
                                                <li
                                                    class="sidemenu-item redirect-cls"
                                                    *ngIf="
                                                        subMenu.url &&
                                                        subMenu?.redirectTo
                                                    "
                                                >
                                                    <a
                                                        class="sidemenu-link"
                                                        (click)="
                                                            navigateToUrl(
                                                                'https://drive.google.com/drive/u/1/shared-drives'
                                                            )
                                                        "
                                                        routerLinkActive="active"
                                                        [routerLinkActiveOptions]="{
                                                            exact: true
                                                        }"
                                                    >
                                                        {{
                                                            subMenu.menuName
                                                                | translate
                                                        }}
                                                    </a>
                                                </li>
                                                <li
                                                    class="sidemenu-item"
                                                    *ngIf="!subMenu.url"
                                                >
                                                    <mat-expansion-panel
                                                        (opened)="
                                                            nestedPanelOpenState = true
                                                        "
                                                        (closed)="
                                                            nestedPanelOpenState = true
                                                        "
                                                    >
                                                        <mat-expansion-panel-header>
                                                            <mat-panel-title>
                                                                {{
                                                                    subMenu.menuName
                                                                        | translate
                                                                }}
                                                            </mat-panel-title>
                                                        </mat-expansion-panel-header>
                                                        <ul
                                                            class="sidebar-sub-menu"
                                                        >
                                                            <ng-container
                                                                *ngFor="
                                                                    let nestedMenu of subMenu?.subMenus
                                                                "
                                                            >
                                                                <ng-container
                                                                    *ngIf="
                                                                        nestedMenu?.permission
                                                                            | permissions
                                                                    "
                                                                >
                                                                    <li
                                                                        class="sidemenu-item"
                                                                    >
                                                                        <a
                                                                            class="sidemenu-link"
                                                                            [routerLink]="
                                                                                nestedMenu.url
                                                                            "
                                                                            routerLinkActive="active"
                                                                            [routerLinkActiveOptions]="{
                                                                                exact: true
                                                                            }"
                                                                        >
                                                                            {{
                                                                                nestedMenu.menuName
                                                                                    | translate
                                                                            }}
                                                                        </a>
                                                                    </li>
                                                                </ng-container>
                                                            </ng-container>
                                                        </ul>
                                                    </mat-expansion-panel>
                                                </li>
                                            </ng-container>
                                        </ng-container>
                                    </ul>
                                    <ng-container
                                        *ngIf="
                                            mainSidebarList.isMail && isMailOpen
                                        "
                                    >
                                    
                                        <app-mail-sidebar-mail-box
                                            [dashboard_counts]="
                                                fetchedDashboardCount
                                            "
                                            *ngIf="mainSidebarList.isComponent"
                                            (trigger_menu_change)="
                                                sidebarMenuChange($event)
                                            "
                                        >
                                        </app-mail-sidebar-mail-box>
                                    </ng-container>
                                    <ng-container *ngIf="mainSidebarList.isAutoMation">
                                        <app-automation-sidebar></app-automation-sidebar>
                                    </ng-container>
                                </mat-expansion-panel>
                            </ng-container>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                mainSidebarList.url && mainSidebarList.menuName
                            "
                        >
                            <ng-container
                                *ngIf="
                                    mainSidebarList?.permission | permissions
                                "
                            >
                                <a
                                    [routerLink]="mainSidebarList.url"
                                    class="sidebar-menu-link"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                >
                                    <i [class]="mainSidebarList.icon"></i>
                                    <span class="title">
                                        {{
                                            mainSidebarList.menuName | translate
                                        }}
                                    </span>
                                </a>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <!-- <app-mail-sidebar-mail-box [dashboard_counts]="disc" *ngIf=""></app-mail-sidebar-mail-box> -->
                </mat-accordion>
            </div>
        </div>
    </ng-scrollbar>
</div>
